import { ActionType, LogicType, Operator } from '../util/GravityFormInterfaces';
export function isFieldDependentOnChangedField(field, changedField) {
    return changedField.dependentFieldIds.indexOf(field.id) > -1;
}
export function shouldShowField(dependentField, form) {
    if (dependentField.visibility === 'hidden') {
        return false;
    }
    if (!dependentField.conditionalLogic) {
        return true;
    }
    const match = rulesMatch(dependentField, form);
    return shouldShow(match, dependentField.conditionalLogic.actionType);
}
export function applyRule(rule, controllingField) {
    if (!controllingField.isChoiceField) {
        return applyRegularFieldRule(rule, controllingField);
    }
    else {
        return applyChoiceFieldRule(rule, controllingField);
    }
}
export function getFieldIdsWithConditionalLogic(fields) {
    let conditionalFieldIds = [];
    fields.forEach((field) => (conditionalFieldIds = [...conditionalFieldIds, ...field.dependentFieldIds]));
    return new Set(conditionalFieldIds);
}
export function setFieldVisibility(field, visible) {
    field.isVisible = visible;
}
export function getFieldVisibilityClass(field) {
    return getGravityFieldVisibilityClass(getGravityField(field));
}
export function getGravityField(field) {
    return field;
}
export function getGravityForm(form) {
    return form;
}
export function shouldShow(match, actionType) {
    switch (actionType) {
        case ActionType.HIDE:
            return !match;
        case ActionType.SHOW:
            return match;
        default:
            return false;
    }
}
export function rulesMatch(dependentField, form) {
    switch (dependentField.conditionalLogic.logicType) {
        case LogicType.ALL:
            return allRulesMatch(dependentField, form);
        case LogicType.ANY:
            return anyRuleMatches(dependentField, form);
        default:
            return false;
    }
}
export function allRulesMatch(dependentField, form) {
    return dependentField.conditionalLogic.rules.every((rule) => ruleAppliesToField(form, rule));
}
export function anyRuleMatches(dependentField, form) {
    return dependentField.conditionalLogic.rules.some((rule) => ruleAppliesToField(form, rule));
}
export function applyRegularFieldRule(rule, controllingField) {
    const expected = rule.value;
    const actual = controllingField.getValue();
    const actualNumber = Number(actual);
    const expectedNumber = Number(expected);
    const comparingNumbers = !Number.isNaN(actualNumber) && !Number.isNaN(expectedNumber);
    switch (rule.operator) {
        case Operator.IS:
            return actual === expected;
        case Operator.IS_NOT:
            return actual !== expected;
        case Operator.LESS_THAN:
            return comparingNumbers && actualNumber < expectedNumber;
        case Operator.GREATER_THAN:
            return comparingNumbers && actualNumber > expectedNumber;
        case Operator.CONTAINS:
            return actual.indexOf(expected) > -1;
        case Operator.STARTS_WITH:
            return actual.startsWith(expected);
        case Operator.ENDS_WITH:
            return actual.endsWith(expected);
        default:
            return false;
    }
}
export function applyChoiceFieldRule(rule, controllingField) {
    const expected = rule.value;
    const choices = controllingField.choices.filter((choice) => choice.isSelected);
    switch (rule.operator) {
        case Operator.IS:
            return choices.some((choice) => choice.value === expected);
        case Operator.IS_NOT:
            return choices.every((choice) => choice.value !== expected);
        default:
            return false;
    }
}
export function getGravityFieldVisibilityClass(gravityField) {
    return gravityField.isVisible ? '' : 'hidden';
}
export function getGravityFieldFromDateField(field) {
    return field;
}
export function ruleAppliesToField(form, rule) {
    const controllingField = form.fields.find((f) => f.id === rule.fieldId);
    return applyRule(rule, getGravityField(controllingField));
}
//# sourceMappingURL=GravityFormFunctions.js.map